export type NavItem = {
    href: string;
    label: string;
};

export const MAIN_NAV: NavItem[] = [
    { href: "/",        label: "Home" },
    { href: "/about",   label: "About us" },
    { href: "/services",label: "Services" },
    { href: "/projects",label: "Games" },
    { href: "/blog",    label: "Blog" },
    { href: "/contact", label: "Contact" },
];

export const FOOTER_LINKS = [
    { href: "/privacy", label: "Privacy policy" },
];
